import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['closeButton', 'dialog', 'widget']

  disconnect() {
    if (this.isOpen) this.close()
  }

  get isOpen() {
    return !this.element.hidden
  }

  get widgetController() {
    return this.application.getControllerForElementAndIdentifier(
      this.widgetTarget.querySelector('[data-controller~="lemonway-iframe"]'),
      'lemonway-iframe'
    )
  }

  open() {
    this.previouslyFocused = document.activeElement
    this.element.hidden = false
    document.body.classList.add('overflow-hidden')
    this.widgetController.showLoader()
    this.closeButtonTarget.focus()
    requestAnimationFrame(() => requestAnimationFrame(() => this.toggleVisibility(true)))
  }

  toggleVisibility(visible) {
    this.element.classList.toggle('opacity-0', !visible)
    this.dialogTarget.classList.toggle('opacity-0', !visible)
    this.dialogTarget.classList.toggle('translate-y-4', !visible)
  }

  start(onboardingUrl) {
    this.widgetController.start(onboardingUrl)
  }

  close() {
    this.widgetController.stop()
    this.toggleVisibility(false)
    this.element.hidden = true
    document.body.classList.remove('overflow-hidden')
    this.previouslyFocused?.focus()
    this.previouslyFocused = null
  }
}
